import { FunctionComponent } from 'react'

import { Icon, IIconProps } from 'native-base'
import { Path } from 'react-native-svg'

type Props = IIconProps & { size?: number }

export const AlertIcon31: FunctionComponent<Props> = ({ size, ...props }) => {
  const originalWidth = 20.0

  const originalHeight = 20.0

  const maxDim = Math.max(originalWidth, originalHeight)

  const scale = size ? size / maxDim : 1

  const width = originalWidth * scale

  const height = originalHeight * scale

  return (
    <Icon viewBox="0 0 20 20" width={width} height={height} {...props}>
      <Path
        d="M10 0C15.5205 0 20 4.37296 20 9.77326C20 10.2887 19.9225 11.0188 19.8147 11.6361L19.8098 11.6579C19.8086 11.6661 19.8072 11.6734 19.8055 11.6806C19.4679 13.2607 18.294 14.3135 16.8182 14.3135C15.6651 14.3135 14.6791 13.598 14.2802 12.5861C13.4048 14.0335 11.8155 15.0008 10 15.0008C7.23855 15.0008 5 12.7625 5 10.0005C5 7.23857 7.23855 5.00027 10 5.00027C11.6913 5.00027 13.1865 5.84032 14.0913 7.12494L14.0909 5.92486C14.0909 5.67394 14.2945 5.47029 14.5455 5.47029C14.7965 5.47029 15 5.67394 15 5.92486V11.5861C15 12.5898 15.814 13.4044 16.8182 13.4044C17.8447 13.4044 18.6648 12.6689 18.9165 11.4906C18.9188 11.4815 18.9192 11.4797 18.9192 11.4797C19.0185 10.9106 19.0909 10.2287 19.0909 9.77326C19.0909 4.88026 15.0232 0.90914 10 0.90914C4.97682 0.90914 0.909091 4.88026 0.909091 9.77326C0.909091 14.6662 4.97682 18.6374 10 18.6374C11.8063 18.6374 13.5323 18.1228 15.0041 17.1746L13.3513 17C13.1016 16.9736 12.9205 16.75 12.9467 16.5C12.973 16.2509 13.1966 16.0691 13.4464 16.0954L16.1586 16.3809C16.4084 16.4073 16.5895 16.6309 16.5632 16.88L16.2781 19.5929C16.2519 19.8429 16.0282 20.0238 15.7785 19.9974C15.5289 19.9711 15.3478 19.7474 15.374 19.4974L15.5409 17.9073L15.3935 18.0046C13.7985 19.0047 11.9401 19.5465 10 19.5465C4.47955 19.5465 0 15.1735 0 9.77326C0 4.37296 4.47955 0 10 0ZM10 5.90941C7.74064 5.90941 5.90909 7.74133 5.90909 10.0005C5.90909 12.2598 7.74064 14.0917 10 14.0917C12.2594 14.0917 14.0909 12.2598 14.0909 10.0005C14.0909 7.74133 12.2594 5.90941 10 5.90941Z"
        fill="#4775FF"
      />
    </Icon>
  )
}
